"use client";
import RightArrow from "icons/rightChevron.svg";
import LeftArrow from "icons/leftChevron.svg";
import {
  FunctionComponent,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";
import { Container } from "src/components/ct-design";
import { ResultsContext } from "src/context/resultsContext/context";
import { FILTERS_ERROR } from "src/containers/results/constants";
import { CouponData } from "src/context/itineraryContext/types";

interface CouponClientProps {
  children: ReactNode[];
  data: CouponData[];
}
const CouponClient: FunctionComponent<CouponClientProps> = (props) => {
  const { children, data } = props;
  const { noResultsFound } = useContext(ResultsContext);
  const [currentSlide, setCurrentSlide] = useState(0);

  const itemsToShow = 3;

  const handleNext = () => {
    const nextSlide = currentSlide + itemsToShow;
    if (nextSlide >= children?.length) return;

    setCurrentSlide(nextSlide >= children.length ? 0 : nextSlide);
  };

  const handlePrevious = () => {
    const previousSlide = currentSlide - itemsToShow;
    if (previousSlide < 0) return;
    setCurrentSlide(
      previousSlide < 0 ? children.length - itemsToShow : previousSlide
    );
  };

  const getVisibleItems = useMemo(() => {
    let visibleItems = children.slice(currentSlide, currentSlide + itemsToShow);
    if (visibleItems.length < itemsToShow) {
      visibleItems = children.slice(
        children.length - itemsToShow,
        children.length
      );
    }
    return visibleItems;
  }, [children, currentSlide]);

  return noResultsFound?.type.TYPE === FILTERS_ERROR.TYPE ||
    !noResultsFound.value ? (
    <Container className="flex flex-middle mb-2">
      {currentSlide ? (
        <div
          className="c-pointer disable-selection mr-4"
          onClick={handlePrevious}
        >
          <LeftArrow fill="#1A1A1A" />
        </div>
      ) : null}
      {getVisibleItems.map((item, index) => (
        <div key={index} className="mr-4 w-30p" onClick={() => {}}>
          {item}
        </div>
      ))}
      {currentSlide + itemsToShow < data.length ? (
        <div
          className={`${
            !currentSlide ? "ml-5" : "ml-1"
          } c-pointer disable-selection`}
          onClick={handleNext}
        >
          <RightArrow fill="#1A1A1A" />
        </div>
      ) : null}
    </Container>
  ) : null;
};

export default CouponClient;
